import { render, staticRenderFns } from "./WrongQuestions.vue?vue&type=template&id=90d3b534"
import script from "./WrongQuestions.vue?vue&type=script&lang=js"
export * from "./WrongQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports